export const UrlQuery = {
  /**
   * Query used on PDP.
   * When this query is assigned, PDP personazation should use multiple segmentation from pet profile
   * */
  multiSegmentMode: 'msm',
} as const;

export type UrlQuery = (typeof UrlQuery)[keyof typeof UrlQuery];
